<page-heading
  [title]="'report.attendanceList.pageTitle' | translate"
  [description]="'report.attendanceList.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-8 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="
                  'report.attendanceList.searchPlaceholder' | translate
                "
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div
              class="col-xs-6 col-md-6 col-lg-4 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading,
                }"
                (click)="exportAttendanceReportToExcel()"
                [matTooltip]="'report.attendanceList.exportToExcel' | translate"
              >
                @if (isLoading) {
                  <mat-spinner
                    [diameter]="25"
                    mode="indeterminate"
                  ></mat-spinner>
                } @else {
                  <i class="ri-file-text-line"></i>
                }
              </button>

              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading,
                }"
                (click)="exportAttendanceReportToPdf()"
                [matTooltip]="'report.attendanceList.exportToPdf' | translate"
              >
                @if (isLoading) {
                  <mat-spinner
                    [diameter]="25"
                    mode="indeterminate"
                  ></mat-spinner>
                } @else {
                  <i class="ri-share-box-fill"></i>
                }
              </button>
            </div>
          </div>
          <div class="row g-2 mt-2 align-items-center">
            <!-- Date picker -->
            <div class="col-xs-12 col-sm-6 col-md-4 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.attendanceList.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.attendanceList.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.attendanceList.select' | translate"
                  >
                    <mat-option value="1">{{
                      "report.attendanceList.today" | translate
                    }}</mat-option>
                    <mat-option value="7">{{
                      "report.attendanceList.last7Days" | translate
                    }}</mat-option>
                    <mat-option value="15">{{
                      "report.attendanceList.last15Days" | translate
                    }}</mat-option>
                    <mat-option value="30">{{
                      "report.attendanceList.last30Days" | translate
                    }}</mat-option>
                    <mat-option value="60">{{
                      "report.attendanceList.last60Days" | translate
                    }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <!-- Filtro Canal -->
            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                  <button mat-menu-item (click)="searchByChannel(null)">
                    {{ "report.attendanceList.all" | translate }}
                  </button>
                  @for (channel of listChannel; track $index) {
                    <button mat-menu-item (click)="searchByChannel(channel)">
                      {{ channel.name }}
                    </button>
                  }
                } @else {
                  <h6 class="text-muted m-1">
                    {{ "report.attendanceList.noResultsFound" | translate }}
                  </h6>
                }
              </mat-menu>
            </div>

            <!-- Filtro Departamento -->
            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment }}</span>
              </button>
              <mat-menu
                #filterDepartmentAtt="matMenu"
                class="custom-menu-panel"
              >
                <button mat-menu-item (click)="searchByDepartment(null)">
                  {{ "report.attendanceList.all" | translate }}
                </button>
                @for (department of listDepartmentChannel; track $index) {
                  <button
                    mat-menu-item
                    (click)="searchByDepartment(department)"
                  >
                    {{ department.name }}
                  </button>
                }
              </mat-menu>
            </div>

            <!-- Filtro Tags -->
            <div
              class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="tagMenu"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>Tags</span>
              </button>
            </div>

            <!-- Filtro Usuário (Admin) -->
            @if (isAdmin()) {
              <div
                class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterUserAdm"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                >
                  <span>{{ labelUser }}</span>
                </button>
                <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
                  <button mat-menu-item (click)="searchByUser(null)">
                    {{ "report.attendanceList.all" | translate }}
                  </button>
                  @for (user of attendantsByTeam; track $index) {
                    <button mat-menu-item (click)="searchByUser(user)">
                      {{ user.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Filtro Usuário (Supervisor) -->
            @if (isSupervisor()) {
              <div
                class="col-xs-12 col-sm-6 col-md-4 col-lg-2 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterUserSup"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                >
                  <span>{{ labelUser }}</span>
                </button>
                <mat-menu #filterUserSup="matMenu" class="custom-menu-panel">
                  <button mat-menu-item (click)="searchByUser(null)">
                    {{ "report.attendanceList.all" | translate }}
                  </button>
                  @for (user of attendantsByTeam; track $index) {
                    <button mat-menu-item (click)="searchByUser(user)">
                      {{ user.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Menu Tags -->
            <mat-menu #tagMenu="matMenu" class="custom-menu-panel">
              <div class="col-12 input-trend-search p-2">
                <input
                  class="form-control"
                  type="text"
                  (focus)="onFocusTags()"
                  [formControl]="filterControlTags"
                  (click)="$event.stopPropagation()"
                  [placeholder]="
                    'report.attendanceList.searchTagPlaceholder' | translate
                  "
                />
                <span class="mdi mdi-magnify search-icon mt-2"></span>
              </div>
              @if (allTags.length > 0) {
                @for (tag of allTags; track $index) {
                  <div
                    class="form-check form-checkbox-info m-1"
                    (click)="$event.stopPropagation()"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input"
                      (click)="$event.stopPropagation()"
                      (change)="selectTag($event, tag._id)"
                      [value]="tag._id"
                      [checked]="formGroup.get('tags').value.includes(tag._id)"
                      id="tag{{ tag._id }}"
                    />
                    <label
                      class="form-check-label ms-1"
                      for="tag{{ tag._id }}"
                      (click)="$event.stopPropagation()"
                    >
                      {{ tag.title }}
                    </label>
                  </div>
                }
              } @else {
                <span class="text-muted m-1">{{
                  "report.attendanceList.noTagsFound" | translate
                }}</span>
              }
            </mat-menu>
          </div>
        </form>
      </div>
    </div>
    @if (!loadingContent) {
      <div class="card-body mb-3">
        <div class="d-flex flex-wrap gap-2">
          <div
            class="flex-fill card-hover"
            [ngClass]="{
              'border border-primary-subtle rounded':
                formGroup.get('status').value === 'OVERTIME',
            }"
          >
            <card-graphic-small-component
              [label]="'report.attendanceList.statusOvertime' | translate"
              [total]="attendancesOvertime.toString()"
              [icon]="'error'"
              [selectable]="true"
              [selected]="formGroup.get('status').value === 'OVERTIME'"
              (click)="searchStatus(attendanceStatusEnum.OVERTIME)"
            />
          </div>
          <div
            class="flex-fill card-hover"
            [ngClass]="{
              'border border-primary-subtle rounded':
                formGroup.get('status').value === 'PENDING',
            }"
          >
            <card-graphic-small-component
              [label]="'report.attendanceList.statusPending' | translate"
              [total]="attendancesPending.toString()"
              [icon]="'schedule'"
              [selectable]="true"
              [selected]="formGroup.get('status').value === 'PENDING'"
              (click)="searchStatus(attendanceStatusEnum.PENDING)"
            />
          </div>
          <div
            class="flex-fill card-hover"
            [ngClass]="{
              'border border-primary-subtle rounded':
                formGroup.get('status').value === 'IN_PROGRESS',
            }"
          >
            <card-graphic-small-component
              [label]="'report.attendanceList.statusInProgress' | translate"
              [total]="attendancesInProgress.toString()"
              [icon]="'headset_mic'"
              [selectable]="true"
              [selected]="formGroup.get('status').value === 'IN_PROGRESS'"
              (click)="searchStatus(attendanceStatusEnum.IN_PROGRESS)"
            />
          </div>
          <div
            class="flex-fill card-hover"
            [ngClass]="{
              'border border-primary-subtle rounded':
                formGroup.get('status').value === 'PAUSED',
            }"
          >
            <card-graphic-small-component
              [label]="'report.attendanceList.statusPaused' | translate"
              [total]="attendancesPaused.toString()"
              [icon]="'pause_circle'"
              [selectable]="true"
              [selected]="formGroup.get('status').value === 'PAUSED'"
              (click)="searchStatus(attendanceStatusEnum.PAUSED)"
            />
          </div>
          <div
            class="flex-fill card-hover"
            [ngClass]="{
              'border border-primary-subtle rounded':
                formGroup.get('status').value === 'CLOSED',
            }"
          >
            <card-graphic-small-component
              [label]="'report.attendanceList.statusClosed' | translate"
              [total]="attendancesClosed.toString()"
              [icon]="'block'"
              [selectable]="true"
              [selected]="formGroup.get('status').value === 'CLOSED'"
              (click)="searchStatus(attendanceStatusEnum.CLOSED)"
            />
          </div>
        </div>
      </div>
    }
  </div>
</div>
@if (loadingContent) {
  <content-loading-list></content-loading-list>
}

<div class="card">
  @if (loadingContent) {
    <content-loading-list />
  }
  @if (!loadingContent && pager.total === 0) {
    <empty-records-component
      [message]="'report.attendanceList.emptyMessage' | translate"
      [subMessage]="'report.attendanceList.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  }
  @if (!loadingContent && pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnContact' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnProtocol' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnChannel' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnDepartment' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnStatus' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnTags' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnRating' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.attendanceList.columnDuration' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track item) {
            <tr (click)="openModalAttendance(item)" class="cursor-pointer">
              <td>
                <div class="d-flex flex-column">
                  @if (item?.contact?.name?.length > 15) {
                    <span matTooltip="{{ item?.contact?.name }}">
                      {{ $safeNavigationMigration(item?.contact?.name) | truncate: 15 }}
                    </span>
                  } @else {
                    <span>
                      {{ item?.contact?.name }}
                    </span>
                  }
                  <span class="text-muted font-13">
                    {{ item?.contact?.phone }}
                  </span>
                </div>
              </td>

              <td>
                <span>
                  {{ item?.protocol }}
                </span>
              </td>

              <td>
                <span>
                  @if (!!item?.channel?.name) {
                    <span
                      class="text-[16px]"
                      matTooltip="{{ item.channel?.name }}"
                    >
                      {{ $safeNavigationMigration(item.channel?.name) | truncate: 10 }}
                    </span>
                  } @else {
                    <span
                      class="text-[16px]"
                      matTooltip="{{ item?.channel?.name }}"
                    >
                      {{ $safeNavigationMigration(item?.channel?.name) | truncate: 10 }}
                    </span>
                  }
                </span>
              </td>
              <td>
                <div class="d-flex flex-column">
                  @if (!!item?.department?.name) {
                    @if (item?.department?.name?.length > 10) {
                      <span matTooltip="{{ item?.department?.name }}">
                        {{ item?.department?.name ?? "-" | truncate: 10 }}
                      </span>
                    }
                    @if (item?.department?.name?.length <= 10) {
                      <span>
                        {{ item?.department?.name ?? "-" }}
                      </span>
                    }
                  } @else {
                    <span>-</span>
                  }
                  @if (!!item?.user?.name) {
                    @if (item?.user?.name?.length > 10) {
                      <span
                        class="text-muted font-13"
                        matTooltip="{{ item?.user?.name }}"
                      >
                        {{ item?.user?.name ?? "-" | truncate: 10 }}
                      </span>
                    }
                    @if (item?.user?.name?.length <= 10) {
                      <span class="text-muted font-13">
                        {{ item?.user?.name ?? "-" }}
                      </span>
                    }
                  } @else {
                    <span class="text-muted font-13">-</span>
                  }
                </div>
              </td>
              <td class="position-relative">
                <div class="d-flex flex-column gap-1">
                  <span
                    class="badge text-capitalize font-14"
                    [ngClass]="{
                      'bg-success': item?.status === 'IN_PROGRESS',
                      'bg-warning': item?.status === 'PENDING',
                      'bg-danger': item?.status === 'OVERTIME',
                      'bg-primary': item?.status === 'PAUSED',
                      'bg-secondary': item?.status === 'CLOSED',
                    }"
                  >
                    {{ translateStatus($safeNavigationMigration(item?.status)) }}
                  </span>
                  @if (
                    item?.status === "PENDING" && item?.chatbotStatus?.automated
                  ) {
                    <span
                      class="badge bg-dark p-1 rounded-pill badge-position translate-middle"
                      [matTooltip]="
                        'report.attendanceList.startedByChatbot' | translate
                      "
                    >
                      <i class="mdi mdi-robot"></i>
                    </span>
                  }
                </div>
              </td>
              <td>
                @if (item?.tags?.length) {
                  <div class="d-flex flex-wrap gap-1">
                    @for (tag of item.tags | slice: 0 : 3; track tag._id) {
                      <span
                        class="badge font-12 text-capitalize"
                        [ngStyle]="{
                          'background-color': tag.bgColor,
                          color: (tag.bgColor | readableText: tag.fontColor),
                        }"
                        matTooltip="{{ tag.title }}"
                      >
                        {{ tag.title | truncate: 15 }}
                      </span>
                    }
                    @if (item.tags.length > 3) {
                      <span
                        class="badge bg-light text-dark font-12 cursor-pointer"
                        [matMenuTriggerFor]="allTagsMenu"
                        (click)="$event.stopPropagation()"
                        [matTooltip]="'report.attendanceList.viewMoreTags' | translate"
                      >
                        +{{ item.tags.length - 3 }}
                      </span>
                      <mat-menu
                        #allTagsMenu="matMenu"
                        class="custom-menu-panel"
                      >
                        <div
                          class="d-flex flex-column gap-1 p-2"
                          (click)="$event.stopPropagation()"
                        >
                          @for (tag of item.tags | slice: 3; track tag._id) {
                            <span
                              class="badge font-12 text-capitalize"
                              [ngStyle]="{
                                'background-color': tag.bgColor,
                                color: (tag.bgColor | readableText: tag.fontColor),
                              }"
                            >
                              {{ tag.title }}
                            </span>
                          }
                        </div>
                      </mat-menu>
                    }
                  </div>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>

              <td>
                @if (item?.feedbackCSAT) {
                  <span class="d-flex align-items-center text-muted gap-1">
                    @for (
                      star of getStarRating($safeNavigationMigration(item?.feedbackCSAT));
                      track $index
                    ) {
                      <i class="bi bi-star-fill star"> </i>
                    }
                  </span>
                } @else {
                  <span class="d-flex align-items-center text-muted gap-1">
                    @for (_ of [1, 2, 3, 4, 5]; track $index) {
                      <i class="bi bi-star"></i>
                    }
                  </span>
                }
              </td>
              <td>
                <div class="d-flex flex-column gap-1">
                  <span>
                    {{ getAttendanceDuration(item) }}
                  </span>
                  <span class="text-muted font-13">
                    {{ 'report.attendanceList.columnStart' | translate }}:
                    {{
                      item.createdAt
                        | timezoneDate
                          : "DD/MM/YYYY HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </span>
                  <span class="text-muted font-13">
                    {{ 'report.attendanceList.columnClosed' | translate }}:
                    @if (
                      item.status === "CLOSED" || item.status === "OVERTIME"
                    ) {
                      {{
                        (item.closedAt
                          | timezoneDate
                            : "DD/MM/YYYY HH:mm"
                            : getTimezoneCompanyCurrentUser()) ?? "-"
                      }}
                    } @else {
                      -
                    }
                  </span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
      }
    </div>
  }
</div>
